/**
 * Marketing Providers
 *
 * Lightweight client providers for the public marketing surface.
 *
 * Primary responsibilities:
 * - Provide theme and translations for marketing components
 * - Keep PostHog capture available for homepage and try handoffs
 *
 * Dependencies:
 * - next-themes
 * - PostHogProvider
 * - I18nProvider
 */

'use client'

import { ReactNode } from 'react'
import { ThemeProvider as NextThemesProvider } from 'next-themes'

import { I18nProvider } from '@/components/providers/i18n-provider'
import { PostHogProvider } from '@/context/PostHogProvider'

interface MarketingProvidersProps {
  children: ReactNode
}

export function MarketingProviders({ children }: MarketingProvidersProps) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem={true}
      enableColorScheme={true}
      storageKey="theme"
    >
      <PostHogProvider>
        <I18nProvider>{children}</I18nProvider>
      </PostHogProvider>
    </NextThemesProvider>
  )
}
